export function StringToBool(string) {
  return string == "true" ? true : false;
}
